import {Alert, AlertTitle, Button, Grid} from "@mui/material";
import React, {useState} from "react";
import {DimensionInput2} from "../../../../manufacturing/DimensionInput2";
import {InternalValue, PrepCanvasManager} from "./PrepCanvasManager";
import {genericDistanceParser} from "../../../../../misc/scroller/Table";


export function AutoCalculate(props: {
    nominalHeight: string;
    manager: PrepCanvasManager;
    doorOverCut: string;
    doorUnderCut: string;
    frameUnderCut: string;
}) {

    const [value, setValue] = useState("");
    const valueNum = (() => {
        try {
            return genericDistanceParser(value).universalValue() || 0;
        } catch (e) {
            return 0;
        }
    })()

    const nominalHeightNum = (() => {
        try {
            return genericDistanceParser(props.nominalHeight).universalValue() || 0;
        } catch (e) {
            return 0;
        }
    })()

    return (
        <Alert severity="info">
            <AlertTitle>Auto-Calculate for Standard Height</AlertTitle>
            <div style={{height: 8}} />

            <Grid container spacing={1} alignItems="center">
                <Grid item>
                    <DimensionInput2 value={value} onChange={setValue} label="Nominal Height" />
                </Grid>
                <Grid item>
                    <Button disabled={!value || valueNum < nominalHeightNum} onClick={() => {

                        const mg = new PrepCanvasManager({
                            nominalHeight: valueNum,
                            nominalWidth: 0,
                            overrides: undefined,
                            pair: false,
                            hingeHeight: props.manager.hingeHeight,
                            overrideHingeQty: props.manager.overrideHingeQty,
                            hasDeadbolt: props.manager.hasDeadbolt,
                            overCutDoor: props.doorOverCut ? genericDistanceParser(props.doorOverCut).universalValue() : 0,
                            underCutDoor: props.doorUnderCut ? genericDistanceParser(props.doorUnderCut).universalValue() : 0,
                            underCutFrame: props.frameUnderCut ? genericDistanceParser(props.frameUnderCut).universalValue() : 0,
                        });

                        mg.calculate();

                        // run twice to get items that are affected by other values (e.g. CLD)
                        for(let ct = 0; ct < 2; ct++) {
                            for (let i in mg.values) {
                                const value = mg.values[i] as InternalValue;
                                const other = props.manager.values[i] as InternalValue;

                                other.enabled = value.enabled;
                                if (other.actualValue !== value.actualValue) {
                                    if (value.enabled) {
                                        if (other.cValue === value.actualValue) {
                                            other.value = undefined;
                                        } else {
                                            other.value = value.actualValue;
                                        }

                                        other.actualValue = value.actualValue;
                                    } else {
                                        other.value = undefined;
                                    }
                                }

                                other.changed.emit(true);
                            }

                            // these values need to auto-adjust for door size. According to Ty, we keep the upper
                            // and adjust the lower sides of the door
                            props.manager.clearOverride("cld");
                            props.manager.clearOverride("clf");
                            props.manager.clearOverride("dbf");
                            props.manager.clearOverride("dbd");
                            props.manager.calculate();
                        }

                        setValue("");

                    }}>Update</Button>
                </Grid>
            </Grid>

            {valueNum < nominalHeightNum && <div style={{marginTop: 4}}>Standard height must be &gt;= {props.nominalHeight}</div>}
        </Alert>
    )
}